import templateUrl from './radio-template.html';

export const radioTemplateComponent = {
	bindings: {
		title: '@',
		options: '<',
		defaultSelectedOptionId: '@',
		onChange: '&',
		isRequired : '<',
		radioColor: '@'
	},
	templateUrl,
	controller: class RadioTemplateComponent {
		$onInit() {
			this.radioColor = this.radioColor || "green";
			this.name = new Date().getTime()+Math.random();
			if(this.isRequired === undefined){
				this.isRequired = true;
			}
		}
		
		_onChange($event) {
			this.onChange({
				$event: {
					id: this.defaultSelectedOptionId
				}
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/app/common/components/radio-template/radio-template.component.js